<div class="flex justify-center">
  <div class="w-full max-w-[1200px] animate__animated animate__fadeIn animate__faster z-30">
    <ng-content></ng-content>
  </div>
</div>
